import React from 'react'

const Navigation = () => (
  <nav
    role="navigation"
    className="sticky backdrop-blur-sm bg-white/10 sticky top-0 h-24 flex items-center justify-center z-10"
    aria-label="Main"
  >
    <a href="/">
      <h1 className="text-3xl flex justify-center">madi.dj</h1>
      <h2 className="flex justify-center">[beat] maker</h2>
    </a>
  </nav>
)

export default Navigation
